export default __webpack_public_path__ + "static/media/Hamburger.148cbf67.svg";